<template>
  <div>
    <div v-for="p in $shoppingCart" :key="p.id && p.variant_id">
      <div class="cart-item">
        <!-- <b-form-checkbox
          v-if="$route.name === 'ShoppingCart'"
          :id="`checkbox-group-${p.id}`"
          v-model="p.isChecked"
          @change="$emit('checkProduct')"
          class="my-auto mr-2"
          style="padding: 0px 9px;"
        ></b-form-checkbox>-->
        <div class="cart-item-img">
          <img
            class="cursor-pointer rounded"
            @click="goToItem(p)"
            :src="p.primary_image"
            :alt="p.name"
            @error="(e) => appUtils.onHandleErrorLoadImage(e)"
          />
        </div>
        <div class="cart-item-info flex justify-between flex-column">
          <div @click="goToItem(p)" style="width: 100%">
            <h2
              class="text-lg txt-gey-900 hover:text-blue-700 transition-all duration-300 cursor-pointer mb-1 max-line-2 d-flex justify-between"
              :class="{
                invoice:
                  $route.name == 'ProductOrderInvoice' && isAppliedVoucher(p)
              }"
              style="padding: 0px 9px; transform: translate(0px, 5px)"
            >
              {{ p.name }}
              <b-badge
                v-if="
                  (productsVoucherAppliable.includes(p.id) &&
                    [1, 2].includes(voucherData.type)) ||
                  ($route.name == 'ProductOrderInvoice' && isAppliedVoucher(p))
                "
                class="coupon"
                variant="warning"
              >
                <span
                  v-if="
                    voucherDiscountPercent ||
                    (p.voucher_info && p.voucher_info.discount_percentage)
                  "
                >
                  -{{
                  voucherDiscountPercent ||
                  (p.voucher_info && p.voucher_info.discount_percentage)
                  }}%
                </span>
                <span v-else>
                  -{{
                  appUtils.numberFormat(
                  voucherData.discount_amount ||
                  (p.voucher_info && p.voucher_info.discount_amount),
                  'VND'
                  )
                  }}
                </span>
              </b-badge>
            </h2>
          </div>
          <div class="row items-center" style="width: 100%">
            <div
              class="mb-3 mb-md-0 pe-3 sm:block flex justify-between"
              :class="type !== 'view' ? 'col-md-4' : 'col-md-4'"
            >
              <div class="w-24">
                <el-input-number
                  style="width: 120px"
                  class="cs-color"
                  placeholder="Type something"
                  v-model.number="p.count"
                  :disabled="type === 'view'"
                  size="small"
                  :min="1"
                  :max="p.selected_variant && p.selected_variant.ecom_warehouse_variants.balance"
                >
                  <i
                    v-if="type !== 'view'"
                    slot="prefix"
                    class="el-input__icon el-icon-minus txt-grey-900 cursor-pointer"
                    @click="subtract(p)"
                  ></i>
                  <i
                    v-if="type !== 'view'"
                    slot="suffix"
                    class="el-input__icon el-icon-plus txt-grey-900 cursor-pointer"
                    @click="addMore(p)"
                  ></i>
                </el-input-number>
              </div>

              <div
                class="sm:hidden flex items-center justify-center text-gray-400 hover:text-red-500 transition-all duration-300 cursor-pointer"
                @click="appUtils.rmfromCart(p.id, p.selected_variant.id)"
              >
                <div class="mr-1">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.8499 9.14062L18.1999 19.2106C18.0899 20.7806 17.9999 22.0006 15.2099 22.0006H8.7899C5.9999 22.0006 5.9099 20.7806 5.7999 19.2106L5.1499 9.14062"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.3301 16.5H13.6601"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.5 12.5H14.5"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <p class="fs-16 leading-none mb-0">{{ $t('order_confirm.lbl_delete') }}</p>
              </div>
            </div>
            <div
              class="mb-3 mb-md-0 pe-3 sm:text-right text-left"
              :class="
                type === 'view' && p.order_item_status
                  ? 'col-md-3 text-center'
                  : type === 'view' && !p.order_item_status
                  ? 'col-md-8'
                  : 'col-md-4'
              "
            >
              <div :class="{ 'd-flex product-price': p.is_require_form === 1 }">
                <div class="mb-0 whitespace-nowrap">
                  <span class="txt-pri">
                    {{ getVariantPrice(p) }}
                    VNĐ
                  </span>/
                  <!-- <span
                    v-if="p.default_price && p.default_unit_name"
                    class="text-gray-400"
                  >/ {{ p.default_unit_name }}</span>-->
                  <el-select
                    class="w-24 border-20"
                    v-model="p.selected_variant"
                    placeholder="Select"
                    size="small"
                    :disabled="type === 'view'"
                    @change="handleChangeVariant(p)"
                    value-key="id"
                  >
                    <el-option
                      v-for="variant in p.variants"
                      :key="variant.id"
                      :label="variant.ecom_unit.name"
                      :value="variant"
                    >
                      <div class="flex items-center gap-3 justify-between">
                        <span style="float: left">{{ variant.ecom_unit.name }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">
                          {{
                          variant.price
                          ? appUtils.numberFormat(variant.price)
                          : ''
                          }}
                          VNĐ
                        </span>
                      </div>
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div
              v-if="type !== 'view'"
              class="mb-3 mb-md-0 ps-3 text-right hidden sm:flex items-center justify-end"
              :class="type !== 'view' ? 'col-md-4' : ''"
              style="visibility: visible"
            >
              <div
                class="flex items-center justify-center text-gray-400 hover:text-red-500 transition-all duration-300 cursor-pointer"
                @click="appUtils.rmfromCart(p.id, p.selected_variant.id)"
              >
                <div class="mr-1">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.8499 9.14062L18.1999 19.2106C18.0899 20.7806 17.9999 22.0006 15.2099 22.0006H8.7899C5.9999 22.0006 5.9099 20.7806 5.7999 19.2106L5.1499 9.14062"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.3301 16.5H13.6601"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.5 12.5H14.5"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <p
                  class="fs-16 leading-none mb-0"
                  style="transform: translateY(2px)"
                >{{ $t('order_confirm.lbl_delete') }}</p>
              </div>
            </div>

            <!-- <div
              class="mb-3 pe-3 flex items-center justify-start"
            >
              <svg class="min-w-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_33063_3143" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_33063_3143)">
                <path d="M4 22V11H2V5H7.2C7.11667 4.85 7.0625 4.69167 7.0375 4.525C7.0125 4.35833 7 4.18333 7 4C7 3.16667 7.29167 2.45833 7.875 1.875C8.45833 1.29167 9.16667 1 10 1C10.3833 1 10.7417 1.07083 11.075 1.2125C11.4083 1.35417 11.7167 1.55 12 1.8C12.2833 1.53333 12.5917 1.33333 12.925 1.2C13.2583 1.06667 13.6167 1 14 1C14.8333 1 15.5417 1.29167 16.125 1.875C16.7083 2.45833 17 3.16667 17 4C17 4.18333 16.9833 4.35417 16.95 4.5125C16.9167 4.67083 16.8667 4.83333 16.8 5H22V11H20V22H4ZM14 3C13.7167 3 13.4792 3.09583 13.2875 3.2875C13.0958 3.47917 13 3.71667 13 4C13 4.28333 13.0958 4.52083 13.2875 4.7125C13.4792 4.90417 13.7167 5 14 5C14.2833 5 14.5208 4.90417 14.7125 4.7125C14.9042 4.52083 15 4.28333 15 4C15 3.71667 14.9042 3.47917 14.7125 3.2875C14.5208 3.09583 14.2833 3 14 3ZM9 4C9 4.28333 9.09583 4.52083 9.2875 4.7125C9.47917 4.90417 9.71667 5 10 5C10.2833 5 10.5208 4.90417 10.7125 4.7125C10.9042 4.52083 11 4.28333 11 4C11 3.71667 10.9042 3.47917 10.7125 3.2875C10.5208 3.09583 10.2833 3 10 3C9.71667 3 9.47917 3.09583 9.2875 3.2875C9.09583 3.47917 9 3.71667 9 4ZM4 7V9H11V7H4ZM11 20V11H6V20H11ZM13 20H18V11H13V20ZM20 9V7H13V9H20Z" fill="#DE4848"/>
                </g>
              </svg>
              <p>Quà tặng: BILL > 200K - ƯU ĐÃI MUA BỘ 1 NỒI 1 CHẢO NHÔM 4 LỚP CHỐNG DÍNH ĐÁY TỪ ELMICH</p>
            </div>-->

            <div
              v-if="type === 'view' && p.order_item_status"
              class="text-right"
              :class="'col-md-7'"
            >
              <ul class="list-unstyled multi-steps">
                <li
                  v-for="(step, index) in p.deliverable_status
                    .deliverable_state"
                  :key="index"
                  :class="
                    step.order_number === p.order_item_status &&
                    step.order_number !==
                      (step.max_steps ||
                        p.deliverable_status.deliverable_state.length)
                      ? 'is-active'
                      : ''
                  "
                >{{ step.title }}</li>
              </ul>
            </div>
          </div>
          <small
            class="text-left w-100"
            style="margin: 4px 0 0 24px"
            v-if="$route.name === 'ShoppingCart'"
          >
            Còn
            <b>{{p.selected_variant && appUtils.numberFormat(p.selected_variant.ecom_warehouse_variants.balance)}}</b> sản phẩm trong kho
          </small>
        </div>
      </div>
      <div
        v-if="isShowButtonOpenModalUploadFileAttacgment(p)"
        class="flex items-center row border-bottom py-2"
      >
        <div class="flex gap-1 items-center">
          <div
            class="inline-block border-b-4 border-solid border-t-0 border-r-0 border-l-0 border-pri-900"
          >
            <span class="txt-grey-900 fs-18 fw-500">{{ $t('order_confirm.lbl_require_docs') }}</span>
          </div>
          <div>
            <b-badge
              v-if="
                p.is_require_form === 1 &&
                !isCartItemHasFullRequirement(p) &&
                $route.name !== 'ProductOrderInvoice'
              "
              href="#"
              variant="warning"
              :id="`tooltip-target-${p.id}`"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 16C11.8022 16 11.6088 16.0587 11.4444 16.1686C11.2799 16.2784 11.1518 16.4346 11.0761 16.6173C11.0004 16.8001 10.9806 17.0011 11.0192 17.1951C11.0578 17.3891 11.153 17.5673 11.2929 17.7071C11.4327 17.847 11.6109 17.9422 11.8049 17.9808C11.9989 18.0194 12.1999 17.9996 12.3827 17.9239C12.5654 17.8482 12.7216 17.72 12.8314 17.5556C12.9413 17.3911 13 17.1978 13 17C13 16.7348 12.8946 16.4805 12.7071 16.2929C12.5195 16.1054 12.2652 16 12 16ZM22.67 17.47L14.62 3.47003C14.3598 3.00354 13.9798 2.61498 13.5192 2.3445C13.0586 2.07401 12.5341 1.9314 12 1.9314C11.4658 1.9314 10.9414 2.07401 10.4808 2.3445C10.0202 2.61498 9.64016 3.00354 9.37997 3.47003L1.37997 17.47C1.11076 17.924 0.96611 18.441 0.960612 18.9688C0.955114 19.4966 1.08897 20.0166 1.34865 20.4761C1.60834 20.9356 1.98467 21.3185 2.43965 21.5861C2.89463 21.8536 3.41215 21.9964 3.93997 22H20.06C20.592 22.0053 21.1159 21.8689 21.5779 21.6049C22.0399 21.341 22.4233 20.9589 22.6889 20.4978C22.9546 20.0368 23.0928 19.5134 23.0895 18.9814C23.0861 18.4493 22.9414 17.9277 22.67 17.47ZM20.94 19.47C20.8523 19.626 20.7244 19.7556 20.5697 19.8453C20.4149 19.935 20.2389 19.9815 20.06 19.98H3.93997C3.76108 19.9815 3.58507 19.935 3.43029 19.8453C3.2755 19.7556 3.14762 19.626 3.05997 19.47C2.9722 19.318 2.92599 19.1456 2.92599 18.97C2.92599 18.7945 2.9722 18.622 3.05997 18.47L11.06 4.47003C11.1439 4.30623 11.2714 4.16876 11.4284 4.07277C11.5854 3.97678 11.7659 3.92599 11.95 3.92599C12.134 3.92599 12.3145 3.97678 12.4715 4.07277C12.6286 4.16876 12.7561 4.30623 12.84 4.47003L20.89 18.47C20.9892 18.6199 21.0462 18.7937 21.055 18.9732C21.0638 19.1527 21.0241 19.3312 20.94 19.49V19.47ZM12 8.00003C11.7348 8.00003 11.4804 8.10538 11.2929 8.29292C11.1053 8.48046 11 8.73481 11 9.00003V13C11 13.2652 11.1053 13.5196 11.2929 13.7071C11.4804 13.8947 11.7348 14 12 14C12.2652 14 12.5195 13.8947 12.7071 13.7071C12.8946 13.5196 13 13.2652 13 13V9.00003C13 8.73481 12.8946 8.48046 12.7071 8.29292C12.5195 8.10538 12.2652 8.00003 12 8.00003Z"
                  fill="#ffc107"
                />
              </svg>
            </b-badge>
            <b-tooltip
              :target="`tooltip-target-${p.id}`"
              triggers="hover"
              custom-class="require-paper-tooltip-class"
            >
              <div>
                <div>{{ $t('order_confirm.lbl_service_required_docs') }}:</div>
                <ul>
                  <li
                    v-for="form in p.order_form_config.order_form_items"
                    :key="form.id"
                    style="text-align: left"
                  >{{ form.name }}</li>
                </ul>
              </div>
            </b-tooltip>
          </div>
          <!-- <div>
              <span class>#{{ orderId }}</span>
          </div>-->
        </div>
        <div>
          <AttachmentRequiredClone
            :productId="p.id"
            :attachments="getListRequiredAttachments(p)"
            @uploadFile="handleUploadFile"
          />
        </div>
      </div>
      <div class="border-bottom text-sm py-1 row">
        <div class="col-12">
          <div
            class="text-sm flex flex-col mb-2 lg:mb-0"
            v-if="
              getOtherExpenses(p.other_expenses) &&
              getOtherExpenses(p.other_expenses).length
            "
          >
            <div class="txt-grey-900">{{ $t('order_confirm.lbl_other_cost') }}:</div>

            <!-- <div class="font-bold mb-1">{{ $t("Chi phí khác") }}:</div> -->
            <ul class="mb-0">
              <li v-for="(item, index) in getOtherExpenses(p.other_expenses)" :key="index">
                <span v-if="item.name" class="mr-1">{{ item.name }}:</span>
                <span class="txt-pri">
                  <span>{{ item.value && appUtils.numberFormat(item.value) }}</span>
                  <span class="ml-1">{{ item.unit }}</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="font-bold flex col-12 justify-end items-end">
          <span>{{ $t('order_confirm.lbl_total_price') }}:</span>
          <span class="ml-2 txt-pri">{{ getTotalPrice(p) }} VNĐ</span>
        </div>
        <!-- <div
          v-if="$route.name == 'ProductOrderInvoice'"
          class="font-bold flex justify-end"
        >
          <span>{{ $t("Voucher ưu đãi") }}:</span>
          <span class="ml-2 txt-pri">{{ p.discount_amount }} VNĐ</span>
        </div>-->
      </div>
      <div v-if="checkStatusSuccess(p)" class="border-bottom">
        <div class="mt-2">
          <h5>{{ $t('order_confirm.lbl_result') }}</h5>
          <div class="pl-6" v-for="(item, index) in p.document_link" :key="`attachment-${index}`">
            <div v-if="item.url" class="fw-500 py-2 text-center flex items-center">
              <span v-if="item.title" class="italic fw-400">{{ item.title }}:</span>
              <a :href="item.url" class="ml-1 text-green-500 align-middle flex items-center gap-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-check-circle"
                >
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
                <span>
                  <u>{{ getFileName(item.url) }}</u>
                </span>
              </a>
            </div>
            <!-- <div class="text-center mb-2">
              <div v-if="item.url && item.status === 2" class="text-truncate"></div>
              <div class v-else>
                <i>Chưa có thông tin</i>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
import AttachmentRequiredClone from './AttachmentRequiredClone.vue'
import Vue from 'vue'
export default {
  name: 'ShoppingCartItem',
  components: { AttachmentRequiredClone },
  props: {
    type: String,
    productsVoucherAppliable: {
      type: Array,
      default: () => []
    },
    voucherDiscountPercent: {
      type: Number,
      default: 0
    },
    voucherData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      appUtils,
      qty: 0,
      definitionData: [],
      variant_id_select: ''
    }
  },
  computed: {
    selectedProducts() {
      return this.$shoppingCart.filter(p => p.isChecked)
    },
    cart() {
      return this.$shoppingCart
    }
  },
  mounted() {
    this.handleMapData()
  },
  watch: {
    $shoppingCart: {
      handler(data) {
        this.handleMapData()
      },
      deep: true
    }
  },
  methods: {
    getVariantPrice(product) {
      if (!product.selected_variant?.id) return 0
      else
        return appUtils.numberFormat(
          product.variants?.find(elm => elm.id == product.selected_variant?.id)
            ?.price
        )
    },
    isCartItemHasFullRequirement(product) {
      const listUploaded = product?.document_product_attachments
      if (!listUploaded && product.is_require_form) {
        return false
      }
      if (product.order_form_config?.order_form_items) {
        product.order_form_config.order_form_items.forEach(form => {
          if (!listUploaded) {
            return false
          } else {
            const url = listUploaded.find(
              upload => upload.attachmentId === form.id
            )?.url
            if (!url) {
              return false
            }
          }
        })
      }

      return true
    },
    handleUploadFile(payload) {
      this.$emit('uploadFile', payload)
    },
    isShowButtonOpenModalUploadFileAttacgment(product) {
      return (
        (this.$route.name === 'OrderConfirm' ||
          this.$route.name === 'ProductOrderInvoice') &&
        product.is_require_form === 1
      )
    },
    isAppliedVoucher(product) {
      return (
        product.voucher_info?.discount_percentage ||
        product.voucher_info?.discount_amount
      )
    },
    subtract(p) {
      if (p.count <= 1) {
        appUtils.rmfromCart(p.id, p.selected_variant.id)
        return
      }
      p.count--
      appUtils.subtractCart(p, 0)
    },
    addMore(p) {
      if (p.count > p.selected_variant?.ecom_warehouse_variants?.balance)
        p.count = p.selected_variant?.ecom_warehouse_variants?.balance
      p.count++
      appUtils.addToCart(p, p.selected_variant?.ecom_unit_id, 0)
    },
    goToItem(product) {
      this.$router.push({ path: `/marketplace/${product.slug}` })
    },
    handleMapData() {
      if (this.$shoppingCart?.order_item_attachments) {
        this.definitionData = this.$shoppingCart?.order_item_attachments?.map(
          item => {
            const fileName = item?.url?.substring(
              item?.url?.lastIndexOf('/') + 1
            )
            const newFile = this.checkImage(item?.url)
              ? item.url
              : { url: item.url, name: fileName }
            return {
              ...item,
              selectedFile: newFile,
              isImage: this.checkImage(item?.url)
            }
          }
        )
      }
    },
    handleSelectFile(e, item) {
      const file = e.target.files[0]
      if (!file) return
      const fileType = file.type
      const validImageTypes = [
        'image/gif',
        'image/jpeg',
        'image/png',
        'image/jpg'
      ]
      this.$store.commit('orders/updateLoading', true)
      if (validImageTypes.includes(fileType)) {
        const reader = new FileReader()
        reader.addEventListener(
          'load',
          () => {
            item.selectedFile = reader.result
          },
          false
        )
        if (file) {
          reader.readAsDataURL(file)
          item.isImage = true
        }
      } else {
        item.isImage = false
        item.selectedFile = file
      }
      this.uploadFileDefinition(file, item.id, this.ordersId)
    },
    handleChoseFile(id) {
      this.$refs[`refInputEl-${id}`][0].click()
    },
    checkImage(path) {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif']
      const extension = path.substring(path.lastIndexOf('.')).toLowerCase()
      if (imageExtensions.includes(extension)) {
        return true
      }
      return false
    },
    handleClickFile(selectedFile, isImage) {
      const url = isImage ? selectedFile : selectedFile.url
      window.open(url, '_blank')
    },
    getListRequiredAttachments(product) {
      if (this.$route.name === 'ProductOrderInvoice') {
        return product?.form_item_attachments || []
      } else if (this.$route.name === 'OrderConfirm') {
        return (
          product?.order_form_config?.order_form_items?.map(item => {
            const uploaded = product?.document_product_attachments?.find(
              el => el.attachmentId === item.id
            )
            return {
              ...item,
              title: item.name,
              url_exam: item.url,
              url: uploaded?.url ? uploaded?.url : ''
            }
          }) || []
        )
      } else return []
    },
    checkRequiredAttachments(product) {
      return (
        product?.form_item_attachments?.length &&
        product.order_item_status &&
        product.is_require_form
      )
    },
    checkStatusSuccess(product) {
      return product?.document_link?.some(
        item => item?.url && item?.status === 2
      )
    },
    getVariantFromId(product) {
      if (!product.selected_variant?.id) return null
      else
        return product.variants?.find(
          elm => elm.id == product.selected_variant?.id
        )
    },
    getTotalPrice(product) {
      let totalRaw = 0
      // eslint-disable-next-line no-unused-expressions
      product?.other_expenses?.map(item => {
        totalRaw += item?.value
      })
      let total

      const price = this.getVariantFromId(product)?.price || 0
      if (
        this.voucherData?.type === 2 &&
        (this.productsVoucherAppliable.includes(product.id) ||
          !!product.voucher_info?.discount_percentage)
      ) {
        const discount_percent = this.voucherDiscountPercent
          ? this.voucherDiscountPercent
          : product.voucher_info?.discount_percentage
          ? product.voucher_info?.discount_percentage
          : 0
        total = appUtils.numberFormat(
          (price * product.count * (100 - discount_percent)) / 100 +
            (totalRaw || 0)
        )
      } else if (
        this.voucherData?.type === 1 &&
        this.productsVoucherAppliable.includes(product.id)
      ) {
        total = appUtils.numberFormat(
          price * product.count -
            Number(this.voucherData?.discount_amount || 0) +
            (totalRaw || 0)
        )
      } else {
        total = appUtils.numberFormat(price * product.count + (totalRaw || 0))
      }
      return total
    },
    getFileName(url) {
      if (!url) return ''
      const fileName = url.substring(url.lastIndexOf('/') + 1)
      const formatFileName =
        fileName.length <= 53 ? fileName : appUtils.truncateHash(fileName, 50)
      return formatFileName
    },
    getOtherExpenses(data) {
      const otherExpenses = data?.filter(
        item => item?.name !== '' || item?.value !== 0
      )
      return otherExpenses
    },
    handleChangeVariant(p) {
      appUtils.addToCart(p, p.selected_variant?.id, p.count)
      if (p.selected_variant?.id !== p.variant_id)
        appUtils.rmfromCart(p.id, p.variant_id)
    }
  }
}
</script>

<style lang="scss" scoped>
.cart-item {
  display: flex;
  border-bottom: 1px solid rgba(233, 233, 233, 1);
  background: white;
  padding: 12px 8px;
}
.cart-item-img {
  width: 80px;
  height: 80px;
  margin-right: 18px;
  min-width: 80px;
  min-height: 80px;
}
.cart-item-img img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.cart-item-info {
  width: calc(100% - 75px);
  align-items: center;
}
$brand-primary: #476dd6;
$white: #fff;
$grey-light: #ededed;
%remain-steps {
  &:before {
    content: counter(stepNum);
    font-family: inherit;
    font-weight: 700;
  }
  &:after {
    background-color: $grey-light;
  }
}
.multi-steps {
  display: table;
  table-layout: fixed;
  width: 100%;
  position: relative;
  z-index: 1;
  margin-bottom: 0;

  > li {
    counter-increment: stepNum;
    text-align: center;
    display: table-cell;
    position: relative;
    color: $brand-primary;

    &:before {
      content: '\f00c';
      content: '\2713;';
      content: '\10003';
      content: '\10004';
      content: '\2713';
      display: block;
      margin: 0 auto 4px;
      background-color: $white;
      width: 36px;
      height: 36px;
      line-height: 32px;
      text-align: center;
      font-weight: bold;
      border: {
        width: 2px;
        style: solid;
        color: $brand-primary;
        radius: 50%;
      }
    }
    &:after {
      content: '';
      height: 2px;
      width: 100%;
      background-color: $brand-primary;
      position: absolute;
      top: 16px;
      left: 50%;
      z-index: -1;
    }
    &:last-child {
      &:after {
        display: none;
      }
    }

    &.is-active {
      @extend %remain-steps;
      &:before {
        background-color: $white;
        border-color: $brand-primary;
      }

      ~ li {
        color: #808080;
        @extend %remain-steps;
        &:before {
          background-color: $grey-light;
          border-color: $grey-light;
        }
      }
    }
  }
}
.product-price {
  justify-content: space-between;
  align-items: center;
}
.coupon {
  background: #ffc107;
}
.invoice {
  justify-content: flex-start;
  gap: 10px;
}

::v-deep {
  .border-20 {
    input {
      border-radius: 20px;
    }
    ul {
      height: 63px;
    }
  }

  .upload-btn {
    width: 150px;
    border: 1px dashed #20419b;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    border-radius: 9px;
    cursor: pointer;
  }
  .cs-text {
    text-decoration: underline;
  }

  .attachment-product {
    background-color: #dee4f8;
    color: #20419b;
    border-radius: 15px;
    padding-left: 4px;
    padding-right: 4px;
    cursor: pointer;
  }

  .cs-color {
    input {
      color: black !important;
    }
  }
}
::v-deep input {
  text-align: center;
  border-radius: 20px;
}
</style>

<style lang="scss">
.require-paper-tooltip-class {
  > .tooltip-inner {
    max-width: max-content;
    ul {
      padding-left: 1rem;
      margin-bottom: 0px;
    }
  }
}
</style>
